module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "news"
  }, _vm._l((_vm.news), function(item, index) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/news/' + item.infoId
      }
    }, [_vm._v(_vm._s(item.infoTitle)), _c('span', {
      staticClass: "time-box"
    }, [_vm._v(_vm._s(_vm._f("time")(item.infoDt)))])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a36ade28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iNews/iNews.vue
// module id = 820
// module chunks = 10